/**
 * Resolves the browser's IANA timezone identifier via
 * `Intl.DateTimeFormat`. Falls back to `'UTC'` when the environment
 * does not expose a resolved zone (older runtimes, certain SSR
 * shims, or test setups stubbing `Intl`).
 *
 * Used by `SidekickConfigProvider` and `useSidekickConfig` as their
 * common default when the host has not supplied an explicit
 * timezone.
 *
 * @returns The resolved IANA timezone string, or `'UTC'` on failure.
 */
export const resolveBrowserTimeZone = (): string => {
  try {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
};
